const APP_PATH = 'app';
// const API_URL = "http://analytikon.harrys:8000/api";
const API_URL = "https://lab.analytikon.gr/api";


const APP_VERSION = '1.2.0';

const USER_ROLE = {
    ADMIN: 0,
    USER: 1,
}

export {
    APP_PATH,
    API_URL,
    APP_VERSION,
    USER_ROLE,
}